// 存量不符 component

<template lang="pug">
div
  div.upper-subpanel.row
    progressBar
    div.upper-subpanel--without-progressbar
      EventTable(v-if="stage === 'selectEvent'" :eventType="eventType")
      Loader(v-if="stage === 'finish'")

  bottom-buttons
    action-button(slot="button-1" title="回主畫面" @click.native="cancel")
    action-button(slot="button-9" title="確認事件" @click.native="startFlow" :clickable="selectedEventId.length > 0")
</template>

<script>
// the query for event data is more complicate,
// if we want to use the EventTable.vue, refract is needed.

import axios from 'axios';
import moment from 'moment';
import progressBar from './flowComp/ProgressBar';
import EventTable from './flowComp/EventTable';
import Loader from './common/Loader';
import BottomButtons from './common/BottomButtons';

export default {
  name: 'StorageError',
  components: {
    progressBar,
    Loader,
    BottomButtons,
    EventTable,
  },
  data() {
    return {
      stage: 'selectEvent',
      eventType: 'STORAGE_ERROR',
      progress: [
        {
          en: 'selectEvent',
          zh: '選擇事件',
        },
        {
          en: 'confirmEvent',
          zh: '確認事件',
        },
      ],
    };
  },
  computed: {
    instance() {
      return this.$store.state.instance;
    },
    storageError() {
      return this.$store.getters.storageError;
    },
    selectedEventId() {
      return this.$store.state.event.selectedEventId;
    },
  },
  mounted() {
    this.$store.commit('SET_APP', '存量不符');
    this.$store.commit('SET_PROGRESS', this.progress);
    this.$store.commit('SET_CURRENT_STEP', 'selectEvent');
  },
  methods: {
    cancel() {
      this.$router.push({ name: 'Main' });
    },
    startFlow() {
      this.stage = 'finish';
      const promises = [];
      this.selectedEventId.forEach((eventId) => {
        promises.push(this.instance.patch(`/api/event/${eventId}/`, { checked: true }));
      });
      axios.all(promises)
      .then(() => {
        this.$store.dispatch('resetAll');
        // this.$router.push({ name: 'Main' });
        this.stage = 'selectEvent';
      });
    },
  },
};
</script>

<style lang="sass" scoped>
.info-col
  width: 100px
</style>




// WEBPACK FOOTER //
// StorageError.vue?393242ce